module.exports = __webpack_public_path__ + "static/media/install-img.a21d918b.png";